import Cookies from "js-cookie"
import PropTypes from "prop-types"
import { useState, Suspense } from "react"
import { connect } from "react-redux"

import { flipImage } from "areas/product/store/actions"
import Button from "components/ui/button"
import Image from "components/ui/image"

const Hint = ({ ...props }) => (
  <div
    className="border-grey-35 text-12 tablet:left-0 before:border-t-grey-35 before:-ml-19 z-39 before:border-18 after:border-15 absolute left-20 top-0 flex items-center rounded-lg border bg-white p-20 shadow-md before:pointer-events-none before:absolute before:left-1/2 before:top-full before:h-0 before:w-0 before:border-transparent after:pointer-events-none after:absolute after:left-1/2 after:top-full after:-ml-16 after:h-0 after:w-0 after:border-transparent after:border-t-white"
    {...props}
  />
)

const InternalFlipIcon = ({ flip, productType, dataCyType = "" }) => {
  const [showHint, setShowHint] = useState(
    typeof Cookies.get("fliphint") === "undefined"
  )

  const closeHint = (e) => {
    e.stopPropagation()
    Cookies.set("fliphint", true)
    setShowHint(false)
  }

  return (
    <>
      {typeof window !== "undefined" && showHint && (
        <Suspense fallback={<div />}>
          <Hint
            data-cy={`product-flip-hint${dataCyType ? `-${dataCyType}` : ""}`}
          >
            <Button onClick={closeHint}>
              <Image
                alt=""
                className="mr-10"
                height="70"
                src={require("images/product/icons/flipicon.png")}
                srcSet={`
                  ${require("images/product/icons/flipicon.png")} 1x,
                  ${require("images/product/icons/flipicon_2x.png")} 2x
                `}
                style={{ width: "60px" }}
                width="80"
              />
              <span>
                This {productType} has two sides. <br />
                Click to flip and view the other side.
              </span>
            </Button>
          </Hint>
          <div className="z-38 fixed inset-0 bg-[rgba(100,100,100,0.7)]" />
        </Suspense>
      )}
      <Button onClick={() => flip()}>
        <Image
          alt="Flip"
          data-cy={`product-flip-hint-icon${
            dataCyType ? `-${dataCyType}` : ""
          }`}
          height="251"
          src={require("images/icons/flip.svg")}
          style={{ width: "35px" }}
          width="230"
        />
      </Button>
    </>
  )
}

InternalFlipIcon.propTypes = {
  dataCyType: PropTypes.string,
  flip: PropTypes.func,
  productType: PropTypes.string,
}

const mapStateToProps = (state) => {
  return {
    productType:
      state.wizard.description.product_type &&
      state.wizard.description.product_type.toLowerCase(),
  }
}

const mapDispatchToProps = (dispatch) => {
  return {
    flip: () => {
      dispatch(flipImage())
    },
  }
}

const FlipIcon = connect(mapStateToProps, mapDispatchToProps)(InternalFlipIcon)

export default FlipIcon
